import { History } from 'history';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { loginAction } from '../../store/actions/loginAction';

import Login from './Login';
import LoginModel from '../../models/Login';

interface LoginProps { history: History, loginUser: Function, redirect: Function };

interface LoginState { fields: LoginModel, errors: LoginModel };

class LoginContainer extends Component<LoginProps, LoginState> {

  state: LoginState = {
    fields: { email: '', password: '' },
    errors: { email: '', password: '' }
  }

  componentWillReceiveProps(newProps: any) {

    if (newProps.loginSuccess) {    
      this.props.history.push('/');
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {

    const fields: LoginModel = { ...this.state.fields };

    switch(field) {
      case 'email':
        fields.email = event.target.value;
        this.setState({ fields });
        break;
      case 'password':
        fields.password = event.target.value;
        this.setState({ fields });
        break;
      default: break;
    }
  }

  handleSubmit = (event: any) => {
    event.preventDefault();

    if(this.handleValidation()) {

      this.props.loginUser(this.state.fields.email, this.state.fields.password);
    }
  }

  handleValidation(): boolean {

    const fields: LoginModel = { ...this.state.fields };
    const errors: LoginModel = { email: '', password: '' };
    let formIsValid: boolean = true;

    if (!fields.email || (fields.email).trim().length === 0) {
      formIsValid = false;
      errors.email = "Field cannot be empty.";
    }

    if (!fields.password || (fields.password).trim().length === 0) {
        formIsValid = false;
        errors.password = "Please enter your password.";
    }
   
    this.setState({ errors: errors });

    return formIsValid;
  }

  toRegister = (): void => {
    this.props.history.push('/register');
  }

  loadResetPasswordPage = (): void => {
    this.props.history.push('/reset_password');
  }

  render() {

    return (
      <Login
        change={ this.handleChange }
        submit={ this.handleSubmit }
        fields={ this.state.fields }
        errors={ this.state.errors }
        loadResetPasswordPage={ this.loadResetPasswordPage }
      />
    );
  }

};

const mapStateToProps = (state: any) => {
  return {
    loginSuccess: state.auth.success
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    loginUser: (email: string, password: string) => dispatch(loginAction(email, password))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);